
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Pagination,
} from "@mui/material";
import { service_enquiry_list } from "../../../api/Enquiry";

// const ServiceEnquiryList = () => {
//   const [enquiryList, setEnquiryList] = useState([]);
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const rowsPerPage = 5; // CHANGE PAGE SIZE HERE

//   const getEnquiryList = () => {
//     service_enquiry_list()
//       .then((res) => {
//         setEnquiryList(res?.data.material_enquiry || []);
//       })
//       .catch((err) => {

//       });
//   };

//   useEffect(() => {
//     getEnquiryList();
//   }, []);

//   // 🔍 FILTER DATA BY SEARCH
//   const filteredData = enquiryList.filter((item) => {
//     return (
//       item?.service?.service_name.toLowerCase().includes(search.toLowerCase()) ||
//       (item?.assigned_vendor || "")
//         .toLowerCase()
//         .includes(search.toLowerCase()) ||
//       (item?.quote || "").toLowerCase().includes(search.toLowerCase())
//     );
//   });

//   // 🔢 PAGINATION LOGIC
//   const paginatedData = filteredData.slice(
//     (page - 1) * rowsPerPage,
//     page * rowsPerPage
//   );

//   return (
//     <Box>
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: { xs: "column", sm: "row" },
//           justifyContent: "space-between",
//           alignItems: { xs: "flex-start", sm: "center" },
//           gap: { xs: 2, sm: 0 },
//           mb: 2,
//         }}
//       >
//         <Typography variant="h5" fontWeight={500} mb={{ xs: 0, sm: 0 }}>
//           Service Enquiry List
//         </Typography>

//         <TextField
//           label="Search ..."
//           variant="outlined"
//           size="small"
//           sx={{
//             width: { xs: "100%", sm: "250px" },
//           }}
//           value={search}
//           onChange={(e) => {
//             setSearch(e.target.value);
//             setPage(1);
//           }}
//         />
//       </Box>


//       <TableContainer component={Paper} sx={{ borderRadius: 3, py: 1 }}>
//         <Table>
//           <TableHead>
//             <TableRow sx={{ backgroundColor: "primary.light", color: "white" }}>
//               <TableCell><strong>ID</strong></TableCell>
//               <TableCell><strong>Service Name</strong></TableCell>
//               <TableCell><strong>Quote</strong></TableCell>
//               <TableCell><strong>Assigned Vendor</strong></TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {paginatedData.length > 0 ? (
//               paginatedData.map((enq) => (
//                 <TableRow key={enq.id}>
//                   <TableCell>{enq.id}</TableCell>
//                   <TableCell>{enq?.service?.service_name}</TableCell>
//                   <TableCell>
//                     {enq?.quote?.length > 20
//                       ? enq.quote.slice(0, 20) + "..."
//                       : enq?.quote}
//                   </TableCell>
//                   <TableCell>
//                     {enq?.assigned_vendor == null
//                       ? "Not Assigned"
//                       : enq?.assigned_vendor}
//                   </TableCell>
//                 </TableRow>
//               ))
//             ) : (
//               <TableRow>
//                 <TableCell colSpan={4} align="center">
//                   No enquiries found
//                 </TableCell>
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <Box display="flex" justifyContent="center" mt={2}>
//         <Pagination
//           count={Math.ceil(filteredData.length / rowsPerPage)}
//           page={page}
//           onChange={(e, value) => setPage(value)}
//           color="primary"
//         />
//       </Box>
//     </Box>
//   );
// };

const ServiceEnquiryList = () => {
  const [enquiryList, setEnquiryList] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(0); // PAGE SIZE
  const [loading, setLoading] = useState(true); // Loading state

  // Fetch service enquiry list
  const getEnquiryList = async () => {
    setLoading(true);
    try {
      const res = await service_enquiry_list();
      setEnquiryList(res?.data.material_enquiry || []);
       setRowsPerPage(res?.data?.pagination.per_page)
    } catch (err) {

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEnquiryList();
  }, []);

  // 🔍 Filter data by search input
const trimmedSearch = search.trim().toLowerCase();

const filteredData = enquiryList.filter((item) => {
  // If search is empty after trimming, include all items
  if (!trimmedSearch) return true;

  const serviceName = item?.service?.service_name ?? "";
  const assignedVendor = item?.assigned_vendor ?? "";
  const quote = item?.quote ?? "";

  return (
    serviceName.toLowerCase().includes(trimmedSearch) ||
    assignedVendor.toLowerCase().includes(trimmedSearch) ||
    quote.toLowerCase().includes(trimmedSearch)
  );
});


  // 🔢 Pagination logic
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Box>
      {/* Header and Search */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 2, sm: 0 },
          mb: 2,
        }}
      >
        <Typography variant="h5" fontWeight={500}>
          Service Enquiry List
        </Typography>

        <TextField
          label="Search Service Enquiry..."
          variant="outlined"
          size="small"
          sx={{ width: { xs: "100%", sm: "250px" } }}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />
      </Box>

      {/* Table */}
      <TableContainer component={Paper} sx={{ borderRadius: 3, py: 1 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "primary.light", color: "white" }}>
              {/* <TableCell><strong>ID</strong></TableCell> */}
              <TableCell><strong>Service Name</strong></TableCell>
              {/* <TableCell><strong>Quote</strong></TableCell> */}
              <TableCell><strong>Assigned Vendor</strong></TableCell>
              <TableCell><strong>Shop Name</strong></TableCell>
              <TableCell><strong>Enquired On</strong></TableCell>

            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              // 🔄 Show loading while fetching
              <TableRow>
                <TableCell colSpan={4} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((enq) => (
                <TableRow key={enq.id}>
                  {/* <TableCell>{enq.id}</TableCell> */}
                  <TableCell>{enq?.service?.service_name ?? "N/A"}</TableCell>
                  {/* <TableCell>
                    {enq?.quote?.length > 20
                      ? enq.quote.slice(0, 20) + "..."
                      : enq?.quote ?? "-"}
                  </TableCell> */}
                  <TableCell>

                    {enq?.agentname?.trim() ? enq.agentname : "Not Assigned"}

                    {/* {enq?.assigned_vendor ?? "Not Assigned"} */}
                  </TableCell>

                  <TableCell>

                    {enq?.shop_name?.trim() ? enq.shop_name : "Not Assigned"}

                  </TableCell>

                     <TableCell>
                      {new Date(enq?.created_at).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No enquiries found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination: show only when not loading */}
      {!loading && filteredData.length > rowsPerPage && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={Math.ceil(filteredData.length / rowsPerPage)}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};



export default ServiceEnquiryList;
